import { getCountryQueryOptions } from "../../queries/countries";

// country is pre-fetched when a user hover a 'view country' link
export const countryViewLoader = ({ params, context: { queryClient } }) => {
  const { countryId } = params;
  queryClient.ensureQueryData(getCountryQueryOptions(countryId, queryClient));
};
